<template>
  <div class="itemsContent">
    <div class="content" :style="{ ...position(), transition: animate ? 'all 300ms ease-in-out' : '' }"
         :class="[ curr % 2 ? 'odd' : 'even' ]">
      <div v-for="(item, index) in items.slice(items.length - 2)">
        <div>
          <img :alt="item.url" :src="item.url"/>
          <h3>{{ item.name }}</h3>
          <p>{{ item.text }}</p>
        </div>
      </div>
      <div v-for="(item, index) in items" :class="focusing(index)">
        <div :style="{ transition: animate ? 'all 300ms ease-in-out' : '' }">
          <img :alt="item.url" :src="item.url"/>
          <h3>{{ item.name }}</h3>
          <p>{{ item.text }}</p>
        </div>
      </div>
      <div v-for="(item, index) in items.slice(0, 3)" :class="focusing(index + items.length)">
        <div :style="{ transition: animate ? 'all 300ms ease-in-out' : '' }">
          <img :alt="item.url" :src="item.url"/>
          <h3>{{ item.name }}</h3>
          <p>{{ item.text }}</p>
        </div>
      </div>
    </div>
    <div class="buttons">
      <div @click="curr -= 1"></div>
      <div @click="curr += 1"></div>
    </div>
  </div>
</template>

<script>

let interval = null

export default {
  name: "whyChooseUs",
  watch: {
    curr: function (value) {
      if (value < 0) {
        this.curr = 0
      }
      if (value === this.items.length) {
        setTimeout(() => {
          this.animate = false
          this.curr = 0
        }, 300)
        return
      }
      clearInterval(interval)
      interval = setInterval(() => {
        this.curr += 1
      }, this.delay)
    }
  },
  methods: {
    position: function () {
      const css = {
        width: (this.items.length + 5) * 300 + 'px',
        transform: `translateX(-${150 + this.curr * 300}px)`
      }
      setTimeout(() => {
        this.animate = true
      }, 1000)

      return css
    },
    focusing: function (index) {
      return index === this.curr ? 'focus' : ''
    }
  },
  data() {
    return {
      items: [
        {
          url: require('../../assets/image/home/lunbo/1.png'),
          name: "聚焦",
          text: "专注电子领域（PCB/PCBA）",
        },
        {
          url: require('../../assets/image/home/lunbo/2.png'),
          name: "全面",
          text: "产品覆盖设计到制造全流程，让设计更懂制造，制造更懂设计",
        },
        {
          url: require('../../assets/image/home/lunbo/3.png'),
          name: "落地",
          text: "深耕工业物联9年，可以自主完成大于100种设备的数据采集，不用再担心上系统踩到数据采集的坑，导致项目烂尾",
        },
        {
          url: require('../../assets/image/home/lunbo/4.png'),
          name: "系统",
          text: "满足未来的BS+微服务集群架构，开源的物联平台",
        },
      ],
      curr: 0,
      delay: 6000,
      animate: true
    }
  },
  mounted() {
    interval = setInterval(() => {
      this.curr += 1
    }, this.delay)
  },
  destroyed() {
    clearInterval(interval)
  }
}
</script>

<style scoped>
.itemsContent {
  width: 1200px;
  height: 500px;
  padding: 20px 0 100px 0;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
}

.itemsContent * {
  box-sizing: border-box;
}

.content {
  height: 100%;
  display: flex;
}

.content > div {
  width: 300px;
  height: 100%;
  padding: 20px;
  position: relative;
  transition: all 300ms ease-in-out;
  bottom: 0;
}

.content.odd > div:nth-child(odd) {
  bottom: -80px;
}

.content.even > div:nth-child(even) {
  bottom: -80px;
}

.content > div > div {
  height: 100%;
  background-color: #F4F4F4;
  border-radius: 6px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.content > div.focus > div {
  color: white;
  background-color: red !important;
  box-shadow: 6px 6px 10px 0 #ff8e8e;
}

.buttons {
  width: 100%;
  display: flex;
  transform: translateY(30px);
  padding: 0 550px;
}

.buttons > div:first-child {
  background: url(../../assets/image/home/lunbo/left.svg) center / 30px no-repeat;
}

.buttons > div:last-child {
  background: url(../../assets/image/home/lunbo/right.svg) center / 30px no-repeat;
}

.buttons > div {
  width: 30px;
  height: 30px;
  cursor: pointer;
}

img {
  width: 80px;
  margin: 40px 0 20px 0;
}

p {
  margin-top: 10px;
  font-size: 12px;
}
</style>
